import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    borderTop: `1px solid #dfe4e7`,
    display: 'grid',
    gridRowGap: theme.spacing(2),
    gridColumnGap: theme.spacing(6),
    [theme.breakpoints.up('lg')]: {
      maxWidth: 1100,
      gridTemplateColumns: '370px 1fr',
    },
  },
  answer: {
    color: '#a5c8dc',
  },
}));

function FaqItem({ question, children }) {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <Typography variant="h5" color="inherit">
        {question}
      </Typography>
      <Typography component="p" className={classes.answer} variant="h6">
        {children}
      </Typography>
    </section>
  );
}

export default FaqItem;
